export default __webpack_public_path__ + "static/img-art-pandas-profiling-1-059cbb44291e39d1cc0a38cad2fb8d6b.webp";